<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 18L16 12M16 12L10 6M16 12L3 12" stroke="#F6F6F6" stroke-linejoin="round" />
    <path d="M18.5 6V18" stroke="#F6F6F6" />
  </svg>
</template>

<style scoped>
svg {
  width: 24px;
  height: 24px;
}
</style>
